/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minageeveryone2Inputs */

const en_minageeveryone2 = /** @type {(inputs: Minageeveryone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everyone`)
};

const de_minageeveryone2 = /** @type {(inputs: Minageeveryone2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für alle`)
};

/**
* | output |
* | --- |
* | "Everyone" |
*
* @param {Minageeveryone2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const minageeveryone2 = /** @type {((inputs?: Minageeveryone2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minageeveryone2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minageeveryone2(inputs)
	return de_minageeveryone2(inputs)
});
export { minageeveryone2 as "minAgeEveryone" }